//@flow

export type CategoryMenuLayoutType = 'DEFAULT' | '2_COLUMNS' | '3_COLUMNS';
export type ProductCategoryMenuLayout = {
  layout: CategoryMenuLayoutType,
  categories?: string[],
  enabled: boolean,
  groups?: string[][],
};

export type ProductCategoryAisleLayout = {
  categories: string[],
  enabled: boolean,
  displayType?: 'SUB_CATEGORY' | 'PRODUCT',
};

export type ProductCategoryLayout = {
  productCategoryMenu: ProductCategoryMenuLayout,
  productCategoryAisle: ProductCategoryAisleLayout,
};

export type ProductCategoryLayoutRequest = {
  productCategoryMenu?: ProductCategoryMenuLayout,
  productCategoryAisle?: ProductCategoryAisleLayout,
};

export const defaultProductCategoryLayout: ProductCategoryLayout = {
  productCategoryMenu: {
    layout: 'DEFAULT',
    categories: [],
    enabled: true,
    groups: [],
  },
  productCategoryAisle: {
    categories: [],
    enabled: true,
    displayType: 'PRODUCT',
  },
};
